package fyi.moko.hotpl.data.network

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.firestore.firestore
import fyi.moko.hotpl.data.service.UsageEventDto
import fyi.moko.hotpl.data.service.UsageEventSink
import kotlinx.coroutines.CancellationException
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.launch

/**
 * Writes usage events to `/users/{uid}/usage_events/{autoId}` (owner create-only in
 * `firestore.rules.prod`; nothing ever updates or deletes one from the client).
 *
 * The write is handed to the SDK and *not* awaited: a Firestore `set()` only completes once
 * the backend acks, which offline is never — but the SDK has already persisted the pending
 * write locally at that point and replays it in order when connectivity returns. Awaiting
 * would stall the tracker's single consumer behind the first offline event.
 */
class FirestoreUsageEventSink(
    emulatorHost: String? = null,
    private val scope: CoroutineScope,
) : UsageEventSink {
    private val firestore = Firebase.firestore

    init {
        if (emulatorHost != null) {
            try {
                firestore.useEmulator(emulatorHost, 8080)
            } catch (e: Exception) {
                // Ignore re-configuration errors, mirroring the place data source.
            }
        }
    }

    override suspend fun record(uid: String, event: UsageEventDto) {
        val doc = firestore.collection("users/$uid/usage_events").document
        scope.launch {
            try {
                doc.set(event)
            } catch (e: CancellationException) {
                throw e
            } catch (e: Exception) {
                println("FirestoreUsageEventSink: ${event.name} rejected: ${e.message ?: e::class.simpleName}")
            }
        }
    }
}
